export default function B2BFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="px-6 py-10 border-t"
      style={{ background: '#060D1A', borderColor: 'rgba(255,255,255,0.06)' }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="/assets/media/automat-logo.png"
              alt="Automat Logo"
              className="h-8 w-auto object-contain brightness-0 invert opacity-70"
            />
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            <a
              href="/privacidade"
              className="font-b2bbody text-xs text-white/30 hover:text-white/60 transition-colors cursor-pointer"
            >
              Privacidade
            </a>
            <a
              href="/termos"
              className="font-b2bbody text-xs text-white/30 hover:text-white/60 transition-colors cursor-pointer"
            >
              Termos de Uso
            </a>
            <a
              href="/"
              className="font-b2bbody text-xs text-white/30 hover:text-white/60 transition-colors cursor-pointer"
            >
              Site Principal
            </a>
          </div>

          {/* Copyright */}
          <p className="font-b2bbody text-xs text-white/20">
            © {year} Automat. Todos os direitos reservados.
          </p>
        </div>

        {/* Address */}
        <div className="mt-6 pt-6 border-t text-center" style={{ borderColor: 'rgba(255,255,255,0.05)' }}>
          <div className="flex items-start justify-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
              <i className="ri-map-pin-line text-white/25 text-xs" />
            </div>
            <p className="font-b2bbody text-xs text-white/25 leading-relaxed">
              Rua Pais Leme, 215, 17º andar, Pinheiros — CEP 05424-150 — São Paulo - SP
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
